/** Format paise (integer) as Indian rupees with L/Cr suffixes. */
export function formatINR(paise: number): string {
  const rupees = paise / 100;
  if (rupees === 0) return "₹0";
  if (rupees >= 1e7) return `₹${(rupees / 1e7).toFixed(1)}Cr`;
  if (rupees >= 1e5) return `₹${(rupees / 1e5).toFixed(1)}L`;
  if (rupees >= 1e3) return `₹${(rupees / 1e3).toFixed(1)}K`;
  return `₹${rupees.toLocaleString("en-IN")}`;
}
